import { useTranslation } from "react-i18next";
import { HiOutlineTrash } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import FeaturedIcon from "@/components/atoms/FeaturedIcon";
import BasicModalContent from "@/components/atoms/modal-panels/BasicModalContent";

type Props = {
  onClose: (value: boolean) => void;
  onDiscard: () => void;
};

const LeaveWithoutSavingModal = ({ onClose, onDiscard }: Props) => {
  const { t } = useTranslation();

  return (
    <BasicModalContent
      featuredIcon={<FeaturedIcon icon={HiOutlineTrash} size={"lg"} color={"error"} />}
      heading={t("predictive.discard.title")}
      body={t("predictive.discard.description")}
      onClose={onClose}
    >
      <div className="mt-4 grid grid-cols-2 gap-3">
        <Button type={"button"} label={t("cancel")} onClick={() => onClose(false)} color="natural" variants="outline" />
        <Button
          type={"button"}
          label={t("predictive.discard.button")}
          variants="primary"
          color={"error"}
          onClick={onDiscard}
        />
      </div>
    </BasicModalContent>
  );
};

export default LeaveWithoutSavingModal;
